// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import gql from 'graphql-tag';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type AemStaticContentQueryVariables = Types.Exact<{
  path: Types.Scalars['String'];
}>;


export type AemStaticContentQuery = { __typename?: 'Query', aemStaticContent?: string | null };

export type AemHeaderFooterQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AemHeaderFooterQuery = { __typename?: 'Query', aemHeaderFooter?: { __typename?: 'AemHeaderFooter', header?: { __typename?: 'AemHeader', topnav?: Array<{ __typename?: 'AemTopNav', title?: string | null, additionalColumnHeading?: string | null, fullWidthDrawer?: boolean | null, items?: Array<{ __typename?: 'AemTopNavItem', title?: string | null, openNewTab?: boolean | null, menuItem?: boolean | null, url?: string | null, childrens?: Array<{ __typename?: 'AemTopNavItem', title?: string | null, openNewTab?: boolean | null, menuItem?: boolean | null, url?: string | null, childrens?: Array<{ __typename?: 'AemTopNavItem', title?: string | null, openNewTab?: boolean | null, menuItem?: boolean | null, url?: string | null } | null> | null } | null> | null } | null> | null, additionalLinks?: Array<{ __typename?: 'AemTopNavAdditionalLink', altText?: string | null, image?: string | null, url?: string | null, title?: string | null, openNewTab?: boolean | null } | null> | null } | null> | null } | null, footer?: { __typename?: 'AemFooter', trademarkBoldText?: string | null, trademarkSmallText?: string | null, footerLeftContent?: Array<{ __typename?: 'AemFooterLeftContent', title?: string | null, items?: Array<{ __typename?: 'AemFooterLinksItem', linkLabel?: string | null, linkUrl?: string | null, externalUrl?: boolean | null } | null> | null } | null> | null, portfolioLinks?: Array<{ __typename?: 'AemFooterLinksItem', linkLabel?: string | null, linkUrl?: string | null, externalUrl?: boolean | null } | null> | null, legalLinks?: Array<{ __typename?: 'AemFooterLinksItem', linkLabel?: string | null, linkUrl?: string | null, externalUrl?: boolean | null } | null> | null, brandLogo?: { __typename?: 'AemFooterBrandLogo', src?: string | null, alt?: string | null, widths?: Array<number | null> | null, linkUrl?: string | null, title?: string | null, externalUrl?: boolean | null } | null, socialContent?: Array<{ __typename?: 'AemFooterSocialContent', title?: string | null, contentType?: string | null, socialLinks?: Array<string | null> | null, items?: Array<{ __typename?: 'AemFooterBrandLogo', src?: string | null, alt?: string | null, widths?: Array<number | null> | null, linkUrl?: string | null, title?: string | null, externalUrl?: boolean | null } | null> | null } | null> | null, footerRightContent?: Array<{ __typename?: 'AemFooterRightContent', title?: string | null, contentType?: string | null, rightText?: string | null, image?: string | null } | null> | null } | null } | null };


export const AemStaticContentDocument = gql`
    query AemStaticContent($path: String!) {
  aemStaticContent(path: $path)
}
    `;
export type AemStaticContentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AemStaticContentQuery, AemStaticContentQueryVariables>, 'query'> & ({ variables: AemStaticContentQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AemStaticContentComponent = (props: AemStaticContentComponentProps) => (
      <ApolloReactComponents.Query<AemStaticContentQuery, AemStaticContentQueryVariables> query={AemStaticContentDocument} {...props} />
    );
    

/**
 * __useAemStaticContentQuery__
 *
 * To run a query within a React component, call `useAemStaticContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAemStaticContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAemStaticContentQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useAemStaticContentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AemStaticContentQuery, AemStaticContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AemStaticContentQuery, AemStaticContentQueryVariables>(AemStaticContentDocument, options);
      }
export function useAemStaticContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AemStaticContentQuery, AemStaticContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AemStaticContentQuery, AemStaticContentQueryVariables>(AemStaticContentDocument, options);
        }
export type AemStaticContentQueryHookResult = ReturnType<typeof useAemStaticContentQuery>;
export type AemStaticContentLazyQueryHookResult = ReturnType<typeof useAemStaticContentLazyQuery>;
export type AemStaticContentQueryResult = ApolloReactCommon.QueryResult<AemStaticContentQuery, AemStaticContentQueryVariables>;
export const AemHeaderFooterDocument = gql`
    query AemHeaderFooter {
  aemHeaderFooter {
    header {
      topnav {
        title
        additionalColumnHeading
        fullWidthDrawer
        items {
          title
          openNewTab
          menuItem
          url
          childrens {
            title
            openNewTab
            menuItem
            url
            childrens {
              title
              openNewTab
              menuItem
              url
            }
          }
        }
        additionalLinks {
          altText
          image
          url
          title
          openNewTab
        }
      }
    }
    footer {
      footerLeftContent {
        title
        items {
          linkLabel
          linkUrl
          externalUrl
        }
      }
      portfolioLinks {
        linkLabel
        linkUrl
        externalUrl
      }
      legalLinks {
        linkLabel
        linkUrl
        externalUrl
      }
      trademarkBoldText
      trademarkSmallText
      brandLogo {
        src
        alt
        widths
        linkUrl
        title
        externalUrl
      }
      socialContent {
        title
        contentType
        items {
          src
          alt
          widths
          linkUrl
          title
          externalUrl
        }
        socialLinks
      }
      footerRightContent {
        title
        contentType
        rightText
        image
      }
    }
  }
}
    `;
export type AemHeaderFooterComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AemHeaderFooterQuery, AemHeaderFooterQueryVariables>, 'query'>;

    export const AemHeaderFooterComponent = (props: AemHeaderFooterComponentProps) => (
      <ApolloReactComponents.Query<AemHeaderFooterQuery, AemHeaderFooterQueryVariables> query={AemHeaderFooterDocument} {...props} />
    );
    

/**
 * __useAemHeaderFooterQuery__
 *
 * To run a query within a React component, call `useAemHeaderFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `useAemHeaderFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAemHeaderFooterQuery({
 *   variables: {
 *   },
 * });
 */
export function useAemHeaderFooterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AemHeaderFooterQuery, AemHeaderFooterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AemHeaderFooterQuery, AemHeaderFooterQueryVariables>(AemHeaderFooterDocument, options);
      }
export function useAemHeaderFooterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AemHeaderFooterQuery, AemHeaderFooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AemHeaderFooterQuery, AemHeaderFooterQueryVariables>(AemHeaderFooterDocument, options);
        }
export type AemHeaderFooterQueryHookResult = ReturnType<typeof useAemHeaderFooterQuery>;
export type AemHeaderFooterLazyQueryHookResult = ReturnType<typeof useAemHeaderFooterLazyQuery>;
export type AemHeaderFooterQueryResult = ApolloReactCommon.QueryResult<AemHeaderFooterQuery, AemHeaderFooterQueryVariables>;